export default {
  get(): string {
    return document.referrer;
  },
};
